import Model from './Model'

class Role extends Model {
  constructor (initialData) {
    super(initialData, {
      momentKeys: [
        'created_at',
        'updated_at',
      ],
    })
  }

  get shortName () {
    switch (this.name) {
      case 'agency_officer' :
        return 'Officer'
      case 'agency_admin' :
        return 'Admin'
      case 'business_admin' :
        return 'Business Admin'
      case 'super_admin' :
        return 'Super Admin'
      default :
        return 'Unknown Type'
    }
  }
}

export default Role
